import { login, logout, getInfo,register} from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken()||"",
    userInfo:{},
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const userName = userInfo.userName.trim()
      return new Promise((resolve, reject) => {
        login(userName, userInfo.password).then(response => {
          if(response.success){
            const data = response.data
            setToken(data.token)
            commit('SET_TOKEN', data.token)
            commit('SET_USERINFO', data)
          };
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 注册
    Register({ commit }, userData) {
      return new Promise((resolve, reject) => {
        register(userData).then(response => {
          if(response.success){
            const data = response.data
            setToken(data.token)
            commit('SET_TOKEN', data.token)
            commit('SET_USERINFO', data)
          };
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          commit('SET_USERINFO', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(res => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_USERINFO',{})
          removeToken()
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO',{})
        commit('SET_ROLES', [])
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js